import React from "react";
import { Container, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import useMentorsApplied from "./useMentorsApplied";
import { dateDiff, dateFormatter } from "../../../_helpers/dateFormatter";
import Header from "../../Common/Header";
import { user_token } from "../../../_helpers/tokensStored";
import MainLayout from "../../Common/MainLayout";

export default (props) => {
  const userToken = user_token;

  const {
    loading,
    allMentorsApplied,
    jobDetails,
    setLastElement,
    onMentorOpenNotificationClick,
    onViewMentorProfileClick,
    onBackClick,
  } = useMentorsApplied(props);

  return (
    <MainLayout pageName="Applied Mentors">
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <Container className="d-flex justify-content-between align-items-center">
            <div className="left">
              <h2 className="text-dark">
                <button className="border-0 bg-transparent mr-2">
                  <FontAwesomeIcon
                    icon={faAngleLeft}
                    className="text-primary"
                    onClick={onBackClick}
                  />
                </button>
                {userToken?.user &&
                  userToken.user.user_meta_info?.company_details &&
                  userToken.user.user_meta_info.company_details?.name}
              </h2>
            </div>
            <a href="/create-job" className="btn btn-primary">
              Create a new job
            </a>
          </Container>

          <div className="container my-4 d-flex justify-content-between align-items-end">
            <div className=" mt-3">
              <h2 className="d-inline-block mr-3">{jobDetails?.title}</h2>
              <span className="h5 text-grey-4">
                {jobDetails?.state_name &&
                  jobDetails.state_name.charAt(0).toUpperCase() +
                    jobDetails.state_name.slice(1).toLowerCase()}
                ,{" "}
                {jobDetails?.country_name &&
                  jobDetails.country_name.charAt(0).toUpperCase() +
                    jobDetails.country_name.slice(1).toLowerCase()}
              </span>
              <p className="mt-2 font-weight-medium">
                {" "}
                {jobDetails?.total_mentors || 0} total Mentors Applied
              </p>
              <p className="font-weight-medium">
                <span className="text-grey-4">Created on: </span>
                {dateFormatter(jobDetails?.created)}
              </p>
            </div>
            {/* 
            <div
              className="search-box input-group text-right mb-3 border rounded bg-grey"
              style={{ width: "300px" }}
            >
              <input
                type="text"
                className="form-control h-auto border-0 bg-transparent"
                placeholder="Search"
              />
              <div className="input-group-append">
                <button className="btn p-2" type="button">
                  <img
                    src="../assets/images/search-icon.png"
                    alt="search"
                    className="mt-2"
                  />
                </button>
              </div>
            </div> */}
          </div>
        </>
      )}

      <div className="container">
        <div className="d-flex align-items-center mt-4">
          <h4
            className="mb-4 mt-3 text-uppercase mr-3 flex-1"
            style={{ width: "160px" }}
          >
            Applied mentors
          </h4>
          <span className="partition border-bottom mb-2 w-100"></span>
        </div>
        <div className="job-listing">
          {Array.isArray(allMentorsApplied) && allMentorsApplied?.length ? (
            <div className="row">
              {allMentorsApplied &&
                Array.isArray(allMentorsApplied) &&
                allMentorsApplied.map((data, index) => (
                  <div
                    className="col-md-6  mb-4"
                    key={index}
                    ref={setLastElement}
                  >
                    <div className="d-flex border rounded-lg p-3 mb-3 flex-column">
                      <div className="d-flex">
                        <img
                          src={
                            data?.mentor_details &&
                            data.mentor_details?.user_meta_info &&
                            data.mentor_details.user_meta_info?.profile_image
                              ? data?.mentor_details &&
                                data.mentor_details?.user_meta_info &&
                                data.mentor_details.user_meta_info
                                  ?.profile_image
                              : "/assets/images/dummy.png"
                          }
                          alt="mentor"
                          className="mr-3 border-radius-10"
                          style={{ width: 50, height: 50 }}
                        />
                        <div className="job-info">
                          <h3
                            className="font-weight-bold mb-1 text-capitalize cursor-pointer text-primary"
                            onClick={(e) =>
                              onViewMentorProfileClick(
                                data?.id,
                                data?.job_details && data.job_details?.title
                              )
                            }
                          >
                            {data?.mentor_details &&
                              data.mentor_details?.full_name}
                          </h3>
                          <p className="text-grey-4">
                            {data?.mentor_profile_details &&
                              data.mentor_profile_details?.headline}
                          </p>
                        </div>
                      </div>
                      <p className="mt-3 mb-1">
                        <span className="font-weight-medium">Location: </span>
                        {data?.mentor_profile_details &&
                        data.mentor_profile_details?.city_name ? (
                          <span className="text-grey-4 text-capitalize">
                            {data?.mentor_profile_details &&
                              data.mentor_profile_details?.city_name}
                            {data?.mentor_profile_details &&
                            data.mentor_profile_details?.city_name
                              ? ","
                              : null}{" "}
                            {data?.mentor_profile_details &&
                              data.mentor_profile_details?.state_name}
                          </span>
                        ) : (
                          <span className="text-grey-4">Not Mentioned</span>
                        )}
                      </p>
                      <p className="mb-0 mr-2">
                        <span className="font-weight-medium">
                          Expected Salary:{" "}
                        </span>
                        {data?.mentor_profile_details &&
                        data.mentor_profile_details?.expected_salary ? (
                          <>
                            {data?.mentor_profile_details &&
                              data.mentor_profile_details?.expected_salary}
                          </>
                        ) : (
                          <span className="text-grey-4">Not Mentioned</span>
                        )}
                      </p>
                      <div className="job-bottom d-flex align-items-center justify-content-between mt-3 border-top pt-3">
                        <span className="text-muted fs-smallest">
                          Applied{" "}
                          {data?.created && dateDiff(data?.created, new Date())}{" "}
                          ago
                        </span>
                        <button
                          className="btn btn-primary py-2 "
                          onClick={() =>
                            onMentorOpenNotificationClick(data?.id)
                          }
                        >
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div className="msg-bg text-white p-3 border-6 mb-3 mt-4 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
              <p className="mb-0">
                <FontAwesomeIcon
                  icon={faCircleInfo}
                  className="text-white mr-2"
                />
                No Applied Mentors Found
              </p>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
};
